import { parseFootnotes } from './parseFootnotes.mjs';
import { transformPropertyValues } from './transformPropertyValues.mjs';
"use strict";
const transformProductForCompare = ({
  product,
  storeId,
  formatMessage,
  additionalProductData
}) => ({
  ...product,
  propertyValues: transformPropertyValues(product.propertyValues, formatMessage, storeId),
  ...(additionalProductData?.find(p => p.id === product.id) || {}),
  footnotes: parseFootnotes(product.footnotes, storeId)
});
export { transformProductForCompare };
//# sourceMappingURL=transformProductForCompare.mjs.map
